import { isNullOrUndefined } from 'ceres/app/helper/utils';

export const setVueLazyImgMixin =
{
    data() {
        return {
            mounted: false
        }
    },

    computed: {
        _lazyContent()
        {
            if(!isNullOrUndefined(this._content) && this.mounted) {
                return this._setLazyImage(this._content);
            }

            return '';
        }
    },

    watch: {
        _lazyContent() {
            document.dispatchEvent(new CustomEvent('update-vue-lazy-img'));
        }
    },

    mounted() {
        this.mounted = true;
    },

    methods: {
        _setLazyImage(html)
        {
            let dom = document.createElement('div');
            dom.innerHTML = html;
            const images = dom.getElementsByTagName('img');

            if(images) {
                for(let i = 0; i < images.length; i++) {
                    if(!images[i].classList.contains('vue--lazy-img')) {

                        images[i].classList.add('vue--lazy-img');

                        images[i].dataset.src = images[i].src;
                        images[i].removeAttribute('src');
                    }
                }
            }

            return dom.innerHTML;
        }
    }
};
